import { i18nTranslationHelper } from '@/i18n'

const t = i18nTranslationHelper.getTEnums

export namespace WeeklyDedication {
  export class Enum {
    static readonly ONE_DAY_PER_WEEK = new Enum(1, t('weeklyDedication.ONE_DAY_PER_WEEK.title'))
    static readonly TWO_DAYS_PER_WEEK = new Enum(2, t('weeklyDedication.TWO_DAYS_PER_WEEK.title'))
    static readonly THREE_DAYS_PER_WEEK = new Enum(
      3,
      t('weeklyDedication.THREE_DAYS_PER_WEEK.title')
    )
    static readonly FOUR_DAYS_PER_WEEK = new Enum(4, t('weeklyDedication.FOUR_DAYS_PER_WEEK.title'))
    static readonly FIVE_DAYS_PER_WEEK = new Enum(5, t('weeklyDedication.FIVE_DAYS_PER_WEEK.title'))
    static readonly SIX_DAYS_PER_WEEK = new Enum(6, t('weeklyDedication.SIX_DAYS_PER_WEEK.title'))
    static readonly EVERY_DAY = new Enum(7, t('weeklyDedication.EVERY_DAY.title'))

    public constructor(
      public readonly id: number,
      public readonly title: string
    ) {}
  }

  export const getAll = (): Enum[] => Object.values(Enum)

  export const getById = (id: number | null): Enum | null =>
    id && Object.values(Enum).find(type => type.id === id)
}
